<style scoped>

</style>
<template>
  <div>
    <ExpenseGroup :type="1" />
  </div>
</template>
<script route="/fin/expense_group_company">
    // import ExpenseGroup from './expense_group'
  import ExpenseGroup from '../expense_group/expense_group';
  export default {
    /* router_info_start */
    router_info: '/fin/expense_group_company',
    /* router_info_end */
    components: {ExpenseGroup},
    data() {
      return {
        //
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
